import React from 'react'
// import { connect } from 'react-redux'
import Row from './Row'
import { renderComponentDropArea, RenderComponentDropArea } from '../ComponentDropArea';
import { allowed_types_component_menu, allowed_types_component, allowed_types_component_with_indepth } from './DropContext';
import { onDropComponent } from './DropComponentCommonFunctions';
import { DnD_element_type } from '../common/ConstantValues';

const RowContainer = (props) => {
  const { isDragging } = props
  // custom Props
  // editingRowIndex : In depth 일 때 사용함, editingIndexes는 props를 내려주기 위해 사용함으로 관계 없음
  let { 
    row, 
    row_index, 
    message_index, 
    // editing_message_index,
    local_id, 
    currentEditMessage, 
    isFirstRow, 
    editingRowIndex, 
    messageActions, 
    editingIndexes,
    currentEditSlidePage,
    editing_message_index,
    editing_row_index,
    editing_slide_page_index,
  } = props
  
  // const {
  //   editing_message_index,
  //   editing_row_index,
  //   editing_slide_page_index,
  // } = editingIndexes

  const editingIndexFlag = editingRowIndex || editingRowIndex === 0

  // Message actions
  let { 
    addComponent, 
    updateDepthCompIndexPos,
    updateComponentIndexPos, 
    setIndexForSlidePage, 
    updateRow, 
    setMsgChanges, 
    copyComponent, 
    setIsDragging,
    setCurrentEditSlidePage,
  } = messageActions

  let layout, attr, col, fillRemainCol, components
  if (row) {
    layout = row.layout
    attr = ((_attr) => {
      if (editingIndexFlag) {
        switch(_attr) {
          case 'NORMAL/' + DnD_element_type.COMPONENT.NORMAL.TEXT.outDepth: 
            return 'NORMAL/' + DnD_element_type.COMPONENT.NORMAL.TEXT.inDepth
          case 'NORMAL/' + DnD_element_type.COMPONENT.NORMAL.BUTTON.outDepth: 
            return 'NORMAL/' + DnD_element_type.COMPONENT.NORMAL.BUTTON.inDepth
          case 'NORMAL/' + DnD_element_type.COMPONENT.NORMAL.IMAGE.outDepth: 
            return 'NORMAL/' + DnD_element_type.COMPONENT.NORMAL.IMAGE.inDepth
          default: 
            console.error('InDepth 컴포넌트로 판별이 되었지만 받은 컴포넌트의 타입이 아무런 InDepth 컴포넌트 타입에 해당되지 않습니다.')
            console.error('[Error result] OutDepth 컴포넌트를 InDepth 영역에 Drop 할 수도 있습니다.')
            console.error('받은 타입을 그대로 반환합니다.')
            return _attr
        }
      }
      return _attr
    })(row.attr)
    col = row.col
    fillRemainCol = row.fillRemainCol
    components = row.components
  }

  const drop_area_style = {
    opacity: 0.8,
  }

  // 컴포넌트 메뉴 onDrop
  const onDrop = (e) => {
    // Disable setMsgChanges when in DepthComponent(Group)
    if (!editingRowIndex && editingRowIndex !== 0) {
      if (setMsgChanges) {
        setMsgChanges(true) // Set message changes to true
      }
    }
    const { component_index } = e
    console.log('editing_slide_page_index :', editing_slide_page_index);
    addComponent({
      message_index : message_index,
      row_index : row_index,
      rowIndexDetail: editingRowIndex,
      ...e,
      slidePageIndex: editing_slide_page_index,
    })
  }

  // 컴포넌트 메뉴 onDrop index 0 전용 Method wrapper
  const onDrop_wrap = (e) => {
    // Disable setMsgChanges when in DepthComponent(Group)
    if (!editingRowIndex && editingRowIndex !== 0) {
      if (setMsgChanges) {
        setMsgChanges(true) // Set message changes to true
      }
    }
    onDrop({
      ...e,
      rowIndexDetail: 0
    })
  }

  // 컴포넌트 onDrop to Update index position
  const _onDropComponent = (e) => {
    console.log('RowContainer change position :');
    // Disable setMsgChanges when in DepthComponent(Group)
    if (!editingRowIndex && editingRowIndex !== 0) {
      if (setMsgChanges) {
        setMsgChanges(true) // Set message changes to true
      }
    }
    const { rowIndexDetail, type, prefix_type } = e
    console.log('editing_slide_page_index :', editing_slide_page_index);
    e = { ...e,
      rowIndex: rowIndexDetail || rowIndexDetail === 0 ? rowIndexDetail : e.rowIndex,
      row_index_detail: editingRowIndex, // target
      slide_page_index: editing_slide_page_index
    }
    // Logic for depth components
    if (type === DnD_element_type.COMPONENT.NORMAL.GROUP && prefix_type === "NORMAL") {
      onDropComponent(updateDepthCompIndexPos, e, message_index, row_index)
      return
    }
    onDropComponent(updateComponentIndexPos, e, message_index, row_index)
  }

  /**
   * Row의 Top 고정영역 onDrop component / 해당 영역의 copmponent index는 0으로 고정
   * @param {Object} e 
   */
  const onTopDropComponent = (e) => {
    // Disable setMsgChanges when in DepthComponent(Group)
    if (!editingRowIndex && editingRowIndex !== 0) {
      if (setMsgChanges) {
        setMsgChanges(true) // Set message changes to true
      }
    }
    const { rowIndexDetail, type, prefix_type } = e
    console.log('editing_slide_page_index :', editing_slide_page_index);
    e = { ...e,
      rowIndex: rowIndexDetail || rowIndexDetail === 0 ? rowIndexDetail : e.rowIndex,
      row_index_detail: editingRowIndex,
      slide_page_index: editing_slide_page_index
    }
    // Logic for depth components
    if (type === DnD_element_type.COMPONENT.NORMAL.GROUP && prefix_type === "NORMAL") {
      onDropComponent(updateDepthCompIndexPos, e, message_index, row_index, 0)
      return
    }
    onDropComponent(updateComponentIndexPos, e, message_index, row_index, 0) // 구조상 -1사용 시 0으로(사용자 입장) 값 설정
  }

  // 컴포넌트 onDrop to Update index position (Top area)
  const _onDropComponent_topArea = (e) => {
    // Disable setMsgChanges when in DepthComponent(Group)
    if (!editingRowIndex && editingRowIndex !== 0) {
      if (setMsgChanges) {
        setMsgChanges(true) // Set message changes to true
      }
    }
    const { rowIndexDetail, type, prefix_type } = e
    e = { ...e,
      rowIndex: rowIndexDetail || rowIndexDetail === 0 ? rowIndexDetail : e.rowIndex,
      row_index_detail: 0,
      slide_page_index: editing_slide_page_index
    }
    // Logic for depth components
    if (type === DnD_element_type.COMPONENT.NORMAL.GROUP && prefix_type === "NORMAL") {
      onDropComponent(updateDepthCompIndexPos, e, message_index, row_index)
      return
    }
    onDropComponent(updateComponentIndexPos, e, message_index, row_index)
  }

  /**
   * SliderView에서 지정하고자 하는 슬라이드 페이지 인덱스를 핸들링 (페이지 클릭 시)
   * @param {Number} slide_page_index 
   */
  const handleSetIndexForSlidePage = (slide_page_index) => {
    console.log('slide_page_index :', slide_page_index);
    const { currentEditMessage } = props
    console.log('currentEditMessage :', currentEditMessage);
    if (slide_page_index === 0 || slide_page_index) {
      if (currentEditMessage) {
        const target_slide_page = currentEditMessage[message_index].rows[row_index-1].components[slide_page_index]
        console.log('target_slide_page :', target_slide_page);
        if (target_slide_page) {
          setCurrentEditSlidePage(target_slide_page)
        } else { console.error('인덱스에 해당하는 slide_page를 찾지못하였습니다. (Not found)') }
      } else { console.error('인덱스에 해당하는 slide_page를 찾지못하였습니다. (props.currentEditMessage is null or undefined)') }
    }
    console.log('message_index :', message_index);
    console.log('row_index :', row_index);
    console.log('slide_page_index :', slide_page_index);
    if (slide_page_index  === null) {
      setIndexForSlidePage(null)
    } else {
      setIndexForSlidePage({
        message_index: message_index,
        row_index: row_index,
        slide_page_index: slide_page_index
      })
    }
  }

  const handleRowUpdate = (updateProps) => {
    // Disable setMsgChanges when in DepthComponent(Group)
    if (!editingRowIndex && editingRowIndex !== 0) {
      if (setMsgChanges) {
        setMsgChanges(true) // Set message changes to true
      }
    }
    updateRow({
      message_index: message_index,
      row_index: row_index,
      row_index_detail: editingIndexFlag ? editingRowIndex : null,
      row: updateProps,
    })
  }

  /**
   * 2 depth Drag start, end
   */
  const dragStart = (e) => {
    setIsDragging({
      dragging: true
    })
  }
  const dragEnd = (e) => {
    setIsDragging({
      dragging: false
    })
  }

  /**
   * Trigged when copy slidepage button is clicked
   * @param {Number} copy_msg_index 
   * @param {Number} copy_row_index 
   * @param {Number} copy_comp_index 
   */
  const onCopy = (copy_msg_index, copy_row_index, copy_comp_index) => {
    copyComponent({
      message_index: copy_msg_index,
      row_index: copy_row_index,
      component_index: copy_comp_index,
    })
  }

  const editing =  editing_message_index !== null && editing_row_index !== null
  const editingThis = editing_message_index !== null && editing_row_index !== null && editing_message_index === message_index && row_index === editing_row_index ? true : undefined

  return (
    <React.Fragment>
      {
        /**
         * RowContainer를 Message없이 단독으로 쓸 때에는 Top drop area가 없어 isFirstRow를 추가함
         */
        isFirstRow && (
          isDragging ? (
            /* Drop area for Change component index position function */
            <RenderComponentDropArea
              key={2}
              onDrop={_onDropComponent_topArea}
              DnDOverContent={null}
              overContentArg={drop_area_style}
              allowed_types={editingIndexFlag ? allowed_types_component_with_indepth : allowed_types_component}
            />
          ) : (
            /* In Normal case */
            <RenderComponentDropArea
              key={3}
              onDrop={onDrop_wrap}
              DnDOverContent={null}
              overContentArg={drop_area_style}
              allowed_types={allowed_types_component_menu}
            />
         )
        )
      }
      <Row
        key={local_id}
        message_index={message_index}
        row_index={row_index}
        // editingIndexes={editingIndexes} // !optimization eidting_row_index와 통합
        editing_message_index= {props.editing_message_index}
        editing_row_index= {props.editing_row_index}
        editing_slide_page_index= {props.editing_slide_page_index} 
        messageActions={messageActions}
        editingRowIndex={editingIndexFlag ? editingRowIndex : null} /* Detail index (In depth flag) */
        layout={layout}
        attr={attr}
        col={col}
        fillRemainCol={fillRemainCol}
        components={components}
        isDragging={isDragging}
        onDrop={onDrop}
        onTopComponentDrop={onTopDropComponent}
        setIndexForSlidePage={handleSetIndexForSlidePage}
        dragStart={dragStart}
        dragEnd={dragEnd}
        updateRow={handleRowUpdate}
        editing={editing}
        editingThis={editingThis}
        onCopy={onCopy}
        currentEditMessage={currentEditMessage}
        currentEditSlidePage={currentEditSlidePage}
      />
      {
        isDragging ? (
          /* Drop area for Change component index position function */
          <RenderComponentDropArea 
            key={0}
            onDrop={_onDropComponent}
            DnDOverContent={null}
            overContentArg={drop_area_style}
            allowed_types={editingIndexFlag ? allowed_types_component_with_indepth : allowed_types_component}
          />
        ) : (
          /* In Normal case */
          <RenderComponentDropArea
            key={1}
            onDrop={onDrop}
            DnDOverContent={null}
            overContentArg={drop_area_style}
            allowed_types={allowed_types_component_menu}
          />
        )
      }
      {/* {renderComponentDropArea(onDrop, null, drop_area_style, allowed_types_component_menu)} */}
    </React.Fragment>
  )
}

const mapStateToProps = (state) => ({
  // isDragging: state.DnD.isDragging,
  // currentEditMessage: state.MessageModule.currentEditMessage,
  // slide_page_index: state.SlidePageState.slide_page_index,
  // row_index_detail: state.SlidePageState.row_index,
  // editing_message_index: state.SlidePageState.message_index,
  // editCurrentEditMessage는 조건부 props
  // currentEditMessage: state.SlidePageState.message_index && state.SlidePageState.row_index && state.SlidePageState.slide_page_index ? state.MessageModule.currentEditMessage : null,
})
const mapDispatchToProps = (dispatch) => ({
  // addComponent : (arg) => {
  //   dispatch(addComponent(arg))
  // },
  // updateComponentIndexPos : (arg) => {
  //   dispatch(updateComponentIndexPos(arg))
  // },
  // updateDepthCompIndexPos : (arg) => {
  //   dispatch(updateDepthCompIndexPos(arg))
  // },
  // setIndexForSlidePage : (arg) => {
  //   dispatch(setIndex(arg))
  // },
  // setCurrentEditSlidePage : (slide_page) => {
  //   dispatch(setCurrentEditSlidePage(slide_page))
  // },
  // setIsDragging : (arg) => {
  //   dispatch(setIsDragging(arg))
  // },
  // updateRow : (arg) => {
  //   dispatch(updateRow(arg))
  // },
  // setMsgChanges : (value) => {
  //   dispatch(setMsgChanges(value))
  // },
  // copyComponent : (arg) => {
  //   dispatch(copyComponent(arg))
  // },
})

export default RowContainer